// src/components/SEO.js
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
  title = 'Bombardiers Hockey - Ontario Youth Hockey Team',
  description = 'Building champions on and off the ice through skill development, teamwork, and character.',
  image = '/bomb-puck-logo.png',
  url = window.location.href,
  type = 'website',
}) => {
  const fullImageUrl = image.startsWith('http') ? image : `${window.location.origin}${image}`;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph meta tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Bombardiers Hockey" />

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Image dimensions */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Bombardiers Hockey Team Logo" />
    </Helmet>
  );
};

export default SEO;
